module.exports = __webpack_public_path__ + "media/src/components/Navigation/NotificationHeader/img/mobileBrand-ff84c2eb6191c629753b1781e35748cf.png";